// extracted by mini-css-extract-plugin
export default {"item":"ticker-item_item__Wh1B8"};